import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";

interface tabProps {
  data: any;
}


const __default__ = {
  name: "TabBar",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    data: { type: null, required: true }
  },
  emits: ["chang"],
  setup(__props: any, { expose, emit }) {
  expose();

const props = __props as {
  data: any;
}






const active = ref(0);

// const TabColor = process.env.VUE_APP_TABCOLOR as string;
const TabColor = '#898989';
const TabColorSel = process.env.VUE_APP_TABCOLOR_SEL as string;
const onChange = (value) => {
  // console.log(value);
  // if (value == 0) {
  //   getMsgList()
  // }
  // emit("chang", value);
};


const __returned__ = { props, emit, active, TabColor, TabColorSel, onChange }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})